const normalizeProcessorListName = name => (name || '').toLowerCase();

export const isProcessorTargetAllowed = (processor, target) =>
  !target || !processor || processor.target === target;

export const isProcessorListItemAllowedByNames = (
  processorListItem,
  processorListNames,
  target,
) =>
  !target ||
  !processorListItem ||
  (processorListNames || []).some(
    ({ name }) =>
      normalizeProcessorListName(name) ===
      normalizeProcessorListName(processorListItem.listName),
  );
